import createPersistedState from 'vuex-persistedstate';
import Storage from './storage/Storage';

export default createPersistedState({
    paths: [
        'dro.session',
    ],
    storage: Storage
});



// WEBPACK FOOTER //
// ./src/common/persistedState/index.ts